import { Button, Form, Space } from "antd";
import _t from "../../lang/translate";
import { OpenModalProps } from "../../types/modalTypes";
import assertFC from "../../utilities/assertFC";
import InputNum from "../form/inputNum";
import { renderErrorMessage } from "../messages/errorMessage";


type FormType = {
  mileageRegulation: number | undefined
}
export default function OverrideMileageRegulation<T extends object>({ onSuccess, onCancel, payload }: OpenModalProps<T>) {
  const [tmpForm] = Form.useForm<FormType>();

  const handleSubmit = async (values: FormType) => {
    try {
      onSuccess(values as T);
    } catch (error) {
      renderErrorMessage(error)
    }
  };

  return (
    <Form form={tmpForm} requiredMark={false} layout="vertical" onFinish={handleSubmit}
      initialValues={{ mileageRegulation: payload?.mileageRegulation ?? undefined }}
    >
      <h2 className="modal-title">{_t("reject", "case")}</h2>
      <Form.Item name="mileageRegulation" label={_t("mileage_regulation")}
        help="Slet og gem for at bruge auto-beteregnet kilometerstandsregulering"
      >
        <InputNum />
      </Form.Item>
      <div className="text-right">
        <Space>
          <Button type="ghost" onClick={onCancel}>
            {_t("cancel")}
          </Button>
          <Button htmlType="submit" type="primary">
            {_t("save")}
          </Button>
        </Space>
      </div>
    </Form>
  );
}

assertFC(OverrideMileageRegulation);
